import React from 'react';
import { BodyText, HeadingText, grey600 } from '@paypalcorp/pp-react';
import get from 'lodash/get';
import DonationTerms from './donation-terms';
import DonationForm from './DonationForm';
import styles from './DonationModal.less';
import trimText from '../lib/trimText';
import { ThemeProvider } from '@paypalcorp/pp-react-theme';

const DonationModal = (props) => {
  const charity = props.charity;
  let {
    campaignInfo,
    campaignInfo: {
      templateData: {
        lpContents: { amounts },
      },
    },
  } = props;
  amounts = props.isGroupDonation
    ? get(
        campaignInfo,
        'templateData.giveToGroupSection.groupDonationDetail.gtgAmounts',
        ''
      )
    : amounts;

  const defaultGroupImg = `https://${props.cdnHost}/digitalassets/c/paypal-ui/illustrations/svg/donations.svg`;

  const gtgImage = get(
    campaignInfo,
    'templateData.giveToGroupSection.groupImage'
  );

  const groupDonationImg = gtgImage ? gtgImage : defaultGroupImg;

  const charitySlogan = trimText(124, charity.slogan);
  let logoUrl = props.isGroupDonation ? groupDonationImg : charity.logo_url;

  // TODO: need to get donation terms specific to give to a group

  let charityNpid = props.isGroupDonation
    ? charity.groupVirtualNpid
    : charity.nonprofit_id;

  return (
    <ThemeProvider theme='v2'>
      <div className={styles['donation-modal-container']}>
        <div className={styles['donation-form-container']}>
          <div className={styles['donation-form-charity-container']}>
            <div
              className={styles['npo-avatar']}
              style={{
                background: `url(${logoUrl}) no-repeat center, center`,
                backgroundSize: 'contain',
              }}
            />
            <div className={'charitytitle_container'}>
              <HeadingText as='p' size='sm' className={'charity_name'}>
                {props.isGroupDonation ? charity.groupName : charity.name}
              </HeadingText>
              {!props.isMobile && (
                <BodyText
                  as='p'
                  className={'charity_slogan'}
                  style={{ color: grey600 }}
                >
                  {props.isGroupDonation
                    ? charity.groupModuleDescription
                    : charitySlogan}
                </BodyText>
              )}
              {props.isMobile && (
                <div>
                  <p className={'charity_slogan'} style={{ color: grey600 }}>
                    {props.isGroupDonation
                      ? charity.groupModuleDescription
                      : charitySlogan}
                  </p>
                </div>
              )}
            </div>
          </div>
          <DonationForm
            id={charityNpid}
            i18n={props.i18n}
            amounts={amounts}
            enable={props.enable}
            currencyCode={amounts.currencyCode}
            campaignInfo={campaignInfo}
            fptiInfo={props.fptiInfo}
            csrf={props.csrf}
            isGroupDonation={props.isGroupDonation}
            cdnHost={props.cdnHost}
            {...props}
          />
        </div>
        <hr />
        <div className={styles['donation-terms-container']}>
          <DonationTerms
            i18n={props.i18n}
            donationTerms={
              props.isGroupDonation
                ? 'label.giveToAGroup-terms'
                : charity.charityContent.donationTerms
            }
            donationTermsOverride={
              Array.isArray(campaignInfo.disclaimers) &&
              campaignInfo.disclaimers.length > 0
                ? campaignInfo.disclaimers
                : null
            }
            charity={charity}
          />
        </div>
      </div>
    </ThemeProvider>
  );
};

export default DonationModal;
